import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { PortTypes } from "@assets/types";
import PortService from "@services/PortService";
import { RootState } from "@state/store";

export const getPorts = createAsyncThunk("ports/getPorts", () =>
  PortService.getPorts()
);

export const searchPorts = createAsyncThunk(
  "ports/searchPorts",
  (port: PortTypes.Port) =>
    PortService.searchPorts(port.PortCode, port.CountryCode)
);

interface PortsState {
  ports: PortTypes.Port[];
}

export const initialPortsState: PortsState = {
  ports: [],
};

export const portsSlice = createSlice({
  name: "ports",
  initialState: initialPortsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPorts.rejected, (state) => {
        state.ports = [];
      })
      .addCase(
        getPorts.fulfilled,
        (state, action: PayloadAction<PortTypes.Port[]>) => {
          state.ports = action.payload;
        }
      )
      .addCase(searchPorts.rejected, (state) => {
        state.ports = [];
      })
      .addCase(
        searchPorts.fulfilled,
        (state, action: PayloadAction<PortTypes.Port[]>) => {
          state.ports = action.payload;
        }
      );
  },
});

export const portsState = (state: RootState) => state.portsSlice.ports;

export default portsSlice.reducer;
